import { tapInlineResource, tapMemo, tapResources, } from "@assistant-ui/tap";
import { ClientResource } from "./tapClientResource.js";
import { wrapperResource } from "./wrapperResource.js";
const ClientResourceWithKey = wrapperResource((el) => {
    if (el.key === undefined) {
        throw new Error("tapClientResource: Element has no key");
    }
    return tapInlineResource(ClientResource(el));
});
export function tapClientLookup(getElements, getElementsDeps) {
    const resources = tapResources(() => getElements().map((el) => ClientResourceWithKey(el)), 
    // biome-ignore lint/correctness/useExhaustiveDependencies: getElementsDeps is passed through from caller
    getElementsDeps);
    const keys = tapMemo(() => Object.keys(resources), [resources]);
    // For arrays, track element key -> index mapping
    const keyToIndex = tapMemo(() => {
        return resources.reduce((acc, resource, index) => {
            acc[resource.key] = index;
            return acc;
        }, {});
    }, [resources]);
    const state = tapMemo(() => {
        return resources.map((r) => r.state);
    }, [resources]);
    return {
        state,
        get: (lookup) => {
            if ("index" in lookup) {
                if (lookup.index < 0 || lookup.index >= keys.length) {
                    throw new Error(`tapClientLookup: Index ${lookup.index} out of bounds (length: ${keys.length})`);
                }
                return resources[lookup.index].methods;
            }
            const index = keyToIndex[lookup.key];
            if (index === undefined) {
                throw new Error(`tapClientLookup: Key "${lookup.key}" not found`);
            }
            return resources[index].methods;
        },
    };
}
//# sourceMappingURL=tapClientLookup.js.map